/**
 * Mapping method for different variations of card brands
 * @param brand
 */
 export function mapCardBrand(brand: string): string | null {
    const brandVariations: any = {
        amex: [
            'american-express',
            'american_express',
            'American Express',
        ],
    },
    brandNames: Array<string> = Object.keys(brandVariations);

    for (let brandNameIndex = 0; brandNameIndex < brandNames.length; brandNameIndex++) {
        const brandName: string = brandNames[brandNameIndex],
            foundVariation: string | undefined =
                brandVariations[brandName].find((brandVariation: string) => stripNonAlphanumericChars(brandVariation).toLowerCase() === stripNonAlphanumericChars(brand).toLowerCase());

        if (foundVariation) { return brandName; }
    }

    return null;
}

/**
 * Remove all non alphanumeric characters
 * @param string
 */
 export function stripNonAlphanumericChars(string) {
    return string.replace(/[^0-9a-z]/gi, '');
}

/**
 * Remove white spaces and - signs
 * @param brand
 */
 export function cardBrandFormatter(brand) {
    return brand.replace(/[\s-]/g, '').toLowerCase();
}

/**
 * Get navigationPath based on deep link fs_screen prop
 * @param screen
 */
export function getNavigationPath(screen) {

    let path = '';

    switch (screen) {
        case 'account-settings':
        case 'settings':
            path = 'account-settings';
            break;
        case 'referral':
        case 'invite-and-earn':
            path = 'invite-and-earn';
            break;
        case 'credit':
        case 'credits':
        case 'credit-activity':
            path = 'credit-activity';
            break;
        case 'history':
        case 'past_bookings':
            path = 'history';
            break;
        case 'membership':
            path = 'membership-club';
            break;
        case 'treats':
        case 'deals':
            path = 'treats';
            break;
        case 'login':
        case 'register':
            path = '';
            break;
        default:
            path = screen;
            break;
    }   

    return path;
}

